/**
 * Data hook for the Operations Placed book surface.
 *
 *   usePlaced() — polls GET /api/placed every 30s. Read-only; the
 *   surface is a census, with no write path (cases enter/leave Placed
 *   upstream, through the portal and the staff doors).
 *
 * Polls slower than the worklist surfaces (30s vs 15s): the Placed book is
 * the slowest-moving part of the pipeline — a case's band changes over days,
 * not seconds — so there is nothing to gain from a tight refresh.
 *
 * Spec: engineering/command-center/docs/port-notes/holding-pen.md (evicted 2026-08-29, #775 round 10)
 */

import { PlacedResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const usePlaced = createPollingQuery({
  queryKey: ["placed"] as const,
  path: "/api/placed",
  schema: PlacedResponseSchema,
  refetchIntervalMs: 30_000,
});
